module.exports = __webpack_public_path__ + "static/media/los-angeles-lakers.c2ab0641.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/los-angeles-lakers.svg
// module id = 233
// module chunks = 0